import * as React from 'react'
import Img from "gatsby-image"
import { MultiSizeImgProps } from './'

class MultiSizeImage extends React.Component<MultiSizeImgProps, {}> {
  constructor(props:MultiSizeImgProps) {
    super(props)

    this.handleImageLoad = this.handleImageLoad.bind(this)
    this.getCurrentImage = this.getCurrentImage.bind(this)
  }

  getCurrentImage() {
    const { source: { desktop, tablet, mobile } } = this.props

    const isWindowDefined = typeof window !== `undefined`
    const mqMobile = isWindowDefined && window.matchMedia("(max-width: 415px)").matches
    const mqTablet = isWindowDefined && window.matchMedia("(min-width: 416px)").matches
    const mqDesktop = isWindowDefined && window.matchMedia("(min-width: 768px)").matches

    if (mqDesktop) {
      return desktop
    } else if (mqTablet) {
      return tablet
    } else if (mqMobile) {
      return mobile
    }

    return desktop
  }

  handleImageLoad() {
    const { onImageLoaded } = this.props
    const { width, height } = this.getCurrentImage()

    if (onImageLoaded) {
      onImageLoaded(width, height)
    }
  }

  render() {
    return <Img fixed={this.getCurrentImage()} onLoad={this.handleImageLoad}  />
  }
}

export default MultiSizeImage